import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const isPushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export async function getExistingSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!isPushSupported()) {
    throw new Error('Este navegador não suporta notificações push. No iPhone, instale o app na tela de início primeiro.');
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Permissão de notificação negada. Habilite nas configurações do navegador.');
  }
  const reg = await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  await axios.post(`${API}/push/subscribe`, {
    subscription: sub.toJSON(),
    device_name: navigator.userAgent.slice(0, 100),
  });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getExistingSubscription();
  if (sub) {
    try {
      await axios.post(`${API}/push/unsubscribe`, { subscription: sub.toJSON() });
    } catch (e) {
      // segue mesmo se falhar no backend
    }
    await sub.unsubscribe();
  }
}
